module.exports = __webpack_public_path__ + "img/wujilu.b12cd2ae.png";